import React, { Component } from 'react';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import 'react-dates/initialize';
import 'react-table/react-table.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dates/lib/css/_datepicker.css';
import 'selectivity/styles/selectivity.css';
import '../../css/index.css';
const AlertTemplate = _ref => {
  let {
    style,
    options,
    message,
    close
  } = _ref;
  const alertType = options.type === 'error' ? 'danger' : options.type;
  return /*#__PURE__*/React.createElement("div", {
    className: "alert alert-".concat(alertType),
    style: {
      minWidth: '350px'
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    onClick: close
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), message, "\xA0 \xA0 \xA0 \xA0 \xA0");
};
const options = {
  position: positions.TOP_RIGHT,
  timeout: 4000,
  offset: '30px',
  type: 'info',
  transition: transitions.SCALE
};
export default class IndexJs extends Component {
  render() {
    return /*#__PURE__*/React.createElement(AlertProvider, Object.assign({
      template: AlertTemplate
    }, options), this.props.app);
  }
}